import { render, staticRenderFns } from "./DistributionStatus.vue?vue&type=template&id=a941afa2&scoped=true&"
import script from "./DistributionStatus.vue?vue&type=script&lang=js&"
export * from "./DistributionStatus.vue?vue&type=script&lang=js&"
import style0 from "./DistributionStatus.vue?vue&type=style&index=0&id=a941afa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a941afa2",
  null
  
)

export default component.exports